'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

// promisify 功能并且有timeout, 传Infinity
function promisify(executor, timeout) {
    if (timeout === void 0) { timeout = 3000; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var p1 = new Promise(function (resolve, reject) {
            executor.apply(void 0, __spreadArray([resolve, reject], args));
        });
        // 设置Infinity的timeout则直接返回promise
        if (!isFinite(timeout)) {
            return p1;
        }
        var p2 = new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(new Error("call timeout " + timeout));
            }, timeout);
        });
        return Promise.race([p1, p2]);
    };
}
function promiseAllSettled(promises) {
    var results = [];
    var promiseCount = 0;
    var promisesLength = promises.length;
    return new Promise(function (resolve) {
        var handler = function (res, i) {
            promiseCount += 1;
            results[i] = res;
            if (promiseCount === promisesLength) {
                return resolve(results);
            }
        };
        var _loop_1 = function (i) {
            var p = promises[i];
            p.then(function (res) {
                handler(res, i);
            }, function () {
                handler('', i);
            });
        };
        for (var i = 0; i < promisesLength; i++) {
            _loop_1(i);
        }
    });
}

function getBrowserParam() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.getBrowserParam) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.getBrowserParam)()];
            }
            throw Error("getBrowserParam error: no match jsapi");
        });
    });
}
function getAdvertisingID() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.getAdvertisingID) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.getAdvertisingID)()];
            }
            throw Error("getAdvertisingID error: no match jsapi");
        });
    });
}
function getAppVersion() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.getAppVersion) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.getAppVersion)()];
            }
            throw Error("getAppVersion error: no match jsapi");
        });
    });
}
var app = {
    getBrowserParam: getBrowserParam,
    getAdvertisingID: getAdvertisingID,
    getAppVersion: getAppVersion,
};

function getType() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.getType) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.connection) === null || _d === void 0 ? void 0 : _d.getType)()];
            }
            throw Error("getType error: no match jsapi");
        });
    });
}
var connect = {
    getType: getType,
};

function getQIMEI() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getQIMEI) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getQIMEI)()];
            }
            throw Error("getQIMEI error: no match jsapi");
        });
    });
}
function getIDFV() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getIDFV) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getIDFV)()];
            }
            throw Error("getIDFV error: no match jsapi");
        });
    });
}
function getAndroidID() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getAndroidID) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getAndroidID)()];
            }
            throw Error("getAndroidID error: no match jsapi");
        });
    });
}
function getWifiInfo() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getWifiInfo) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getWifiInfo)()];
            }
            throw Error("getWifiInfo error: no match jsapi");
        });
    });
}
function getImsi() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getImsi) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getImsi)()];
            }
            throw Error("getImsi error: no match jsapi");
        });
    });
}
function getIMEI() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getIMEI) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getIMEI)()];
            }
            throw Error("getIMEI error: no match jsapi");
        });
    });
}
function getVersion() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getVersion) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getVersion)()];
            }
            throw Error("getVersion error: no match jsapi");
        });
    });
}
function getMacAddress() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getMacAddress) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getMacAddress)()];
            }
            throw Error("getMacAddress error: no match jsapi");
        });
    });
}
function getTuringTicket() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.getTuringTicket) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.device) === null || _d === void 0 ? void 0 : _d.getTuringTicket)()];
            }
            throw Error("getTuringTicket error: no match jsapi");
        });
    });
}
var device = {
    getQIMEI: getQIMEI,
    getIDFV: getIDFV,
    getAndroidID: getAndroidID,
    getWifiInfo: getWifiInfo,
    getImsi: getImsi,
    getIMEI: getIMEI,
    getVersion: getVersion,
    getMacAddress: getMacAddress,
    getTuringTicket: getTuringTicket,
};

function onloginUserSwitch(callback) {
    var _a, _b, _c, _d;
    if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.onloginUserSwitch) {
        (_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.event) === null || _d === void 0 ? void 0 : _d.onloginUserSwitch(callback !== null && callback !== void 0 ? callback : (function () { }));
    }
    throw Error("onloginUserSwitch error: no match jsapi");
}
var event = {
    onloginUserSwitch: onloginUserSwitch,
};

function getAccountInfo() {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_d) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.login) === null || _b === void 0 ? void 0 : _b.getAccountInfo) {
                return [2 /*return*/, promisify(window.browser.login.getAccountInfo, Infinity)()];
            }
            // 这是对没有注入到jsapi的polyfill(例如Ipad)
            if ((_c = window === null || window === void 0 ? void 0 : window.x5) === null || _c === void 0 ? void 0 : _c.exec) {
                return [2 /*return*/, promisify(function (resolve, reject) {
                        var _a, _b;
                        (_b = (_a = window === null || window === void 0 ? void 0 : window.x5) === null || _a === void 0 ? void 0 : _a.exec) === null || _b === void 0 ? void 0 : _b.call(_a, resolve, reject, 'login', 'getAccountInfo', []);
                    })()];
            }
            throw Error("getAccountInfo error: no match jsapi");
        });
    });
}
function refreshToken(uin) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            if (!uin || !((_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.login)) {
                throw Error("refreshToken error: no match jsapi or no uin: " + uin);
            }
            return [2 /*return*/, promisify(function (resolve) {
                    var _a, _b;
                    (_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.login) === null || _b === void 0 ? void 0 : _b.refreshToken({ uin: uin }, resolve);
                })()];
        });
    });
}
function showQBLoginPanel(loginPanelOpts) {
    var _a, _b, _c, _d, _e;
    if (loginPanelOpts === void 0) { loginPanelOpts = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_f) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.login) === null || _b === void 0 ? void 0 : _b.showLoginPanel) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.login) === null || _d === void 0 ? void 0 : _d.showLoginPanel, Infinity)(loginPanelOpts)];
            }
            if ((_e = window === null || window === void 0 ? void 0 : window.x5) === null || _e === void 0 ? void 0 : _e.exec) {
                return [2 /*return*/, promisify(function (resolve, reject) {
                        var _a, _b;
                        (_b = (_a = window === null || window === void 0 ? void 0 : window.x5) === null || _a === void 0 ? void 0 : _a.exec) === null || _b === void 0 ? void 0 : _b.call(_a, resolve, reject, 'login', 'showLoginPanel', []);
                    })()];
            }
            throw Error("showQBLoginPanel error: no match jsapi");
        });
    });
}
var login = {
    getAccountInfo: getAccountInfo,
    refreshToken: refreshToken,
    showQBLoginPanel: showQBLoginPanel,
};

function getNetworkType() {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_e) {
            if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.vpn) === null || _b === void 0 ? void 0 : _b.getNetworkType) {
                return [2 /*return*/, promisify((_d = (_c = window === null || window === void 0 ? void 0 : window.browser) === null || _c === void 0 ? void 0 : _c.vpn) === null || _d === void 0 ? void 0 : _d.getNetworkType)()];
            }
            throw Error("getNetworkType error: no match jsapi");
        });
    });
}
var vpn = {
    getNetworkType: getNetworkType,
};

var index = {
    app: app,
    connect: connect,
    device: device,
    event: event,
    login: login,
    vpn: vpn,
};

exports.default = index;
exports.promiseAllSettled = promiseAllSettled;
